/**
 * i18n Initialization — App Router
 *
 * Replaces the `appWithTranslation` HOC from `next-i18next` (Pages Router only).
 * Loads translations from /public/locales/vi/*.json via HTTP on the client.
 * Imported once in providers.tsx to initialize before any component renders.
 */
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const isInitialized = i18n.isInitialized;

if (!isInitialized) {
    i18n.use(HttpBackend)
        .use(initReactI18next)
        .init({
            lng: 'vi',
            fallbackLng: 'vi',
            ns: [
                'common',
                'cart',
                'address',
                'checkout',
                'quote',
                'flash-sale',
                'customer',
                'auth',
                'banner',
                'faq',
                'policy',
                'search-page',
                'terms',
            ],
            defaultNS: 'common',
            interpolation: {
                escapeValue: false, // React already escapes
            },
            backend: {
                loadPath: '/locales/{{lng}}/{{ns}}.json',
            },
            react: {
                useSuspense: false,
            },
        });
}

export default i18n;
